export default "__VITE_ASSET__e2989ca4__"